import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "overlay", "panel"]

  open() {
    this.dialogTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
    this.dialogTarget.offsetHeight
    this.overlayTarget.classList.add("overlay-enter")
    this.overlayTarget.classList.remove("overlay-hidden")
    this.panelTarget.classList.add("panel-enter")
    this.panelTarget.classList.remove("panel-hidden")
  }

  close() {
    this.overlayTarget.classList.remove("overlay-enter")
    this.overlayTarget.classList.add("overlay-hidden")
    this.panelTarget.classList.remove("panel-enter")
    this.panelTarget.classList.add("panel-hidden")

    if (this.prefersReducedMotion) {
      this._afterClose()
    } else {
      this.panelTarget.addEventListener("transitionend", () => this._afterClose(), { once: true })
    }
  }

  closeOnBackdrop(event) {
    if (event.target === this.dialogTarget || event.target === this.overlayTarget) {
      this.close()
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  _afterClose() {
    this.dialogTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }

  get prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches
  }
}
